import React, { useState } from "react";
import Layout from "../Componants/Layout";
import { Button, Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TellUsMoreModal from "../Modal/TellUsMoreModal";
import { Formik, Field, Form } from "formik";
import { Form as reactform } from "react-bootstrap";
import * as Yup from "yup";
import Select from "react-select";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import { formatAndTruncateText, getTheDays, truncateText } from "../utils/HelperFunctions";
import useVendorDetails from "../hooks/VendorDetails";
import PhoneVerifyModal from "../Modal/PhoneVerifyModal";
import toast from "react-hot-toast";
import GiveReviewModal from "../Modal/GiveReviewModal";

const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "4px", // Adds padding inside the control box
    minHeight: "45px", // Ensure minimum height is applied
  }),
};
const validationSchema = Yup.object({
  services: Yup.array()
    .min(1, "Please select at least one service.") // Ensure at least one service is selected
    .required("This field is required."),
});

export default function CustomerDashboard() {
  const Navigate = useNavigate();
  const { data: userDetail, isLoading: userLoading, refetch } = useVendorDetails();
  console.log("userDetailuserDetailuserDetail66", userDetail);
  const [show, setShow] = useState(false);
  const [selectedData, setSelectedData] = useState({
    service: "",
    category: "",
  });

  const [review, setReview] = useState(false)
  const [checkStatus, setCheckStatus] = useState("")
  const [leadID, setLeadID] = useState("")

  const handleReviewClose = () => {
    setReview(false)
    setLeadID("")
  }
  const handleReviewOpen = () => {
    setReview(true)
  }

  const [phoneVerifyModal, setPhoneVerifyModal] = useState(false);
  const handlephoneVerifyModalClose = () => setPhoneVerifyModal(false);




  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: () => {
      return postRequest(`profile/send-otp`);
    },
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });




  const handlePhoneVerify = () => {
    setPhoneVerifyModal(true);
    mutate();
  }

  // Fetch data from API
  const {
    data: enquiriesList,
    error: enquiriesError,
    isLoading: enquiriesLodaing,
    refetch: refresh
  } = useQuery({
    queryKey: ["enquiriesList"],
    queryFn: () => getRequest("/lead/list"),
  });

  const handleClose = () => {
    setShow(false);
    setSelectedData({
      service: "",
      category: "",
    }); // Reset selected data when closing the modal
  };

  // Fetch data from API
  const {
    data: categoryList,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getRequest("/auth/view-category"),
  });

  const options = Array.isArray(categoryList?.data)
    ? categoryList?.data
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.serviceId === item.serviceId)
      )
      .map((item) => ({
        value: item.serviceId,
        label: item.serviceName,
        category: item.categoryId,
      }))
    : [];





  const { mutate: updateEnquiriesStatus } = useMutation({
    mutationFn: (data) => {
      return putRequest("/lead/status", data);
    },
    onSuccess: (data) => {
      if (checkStatus == "Work Complete") {
        handleReviewOpen()
      } else {
        toast.success(`${data?.message}`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
        refresh()
      }
      setCheckStatus("")
    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setCheckStatus("")
    },
  });






  const handleUpdateStatus = (id, status, leadID) => {
    if (status == "Work Complete") {
      setCheckStatus(status)
      setLeadID(leadID)
    }
    const payload = {
      leadId: id,
      status: status
    };
    updateEnquiriesStatus(payload);
  }





  const tooltip = (
    <Tooltip id="tooltip" >
      <div className="tool-desc">
      Once the work is marked as “Complete” and a review has been submitted, the enquiry status is locked.
      This ensures that the job can’t be changed to “Enquired,” “Didn’t Hire Anyone,” or “Hired Someone Else” after completion. No further reviews can be added once the status is finalised
      </div>
    </Tooltip>
  );





  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3>Welcome back, {userDetail?.name}!</h3>
            <p>Here’s your recent activity</p>
            <Row className="mt-4 enquiries-sec">
              <Col lg={12}>
                <h4>
                  Enquiries{" "}
                  (<span>
                    {Array.isArray(enquiriesList?.data) &&
                      enquiriesList?.data?.length}
                  </span>)
                  <OverlayTrigger placement="right"   overlay={tooltip}>
                    <span className="m-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12ZM11.6819 11.0273C11.9289 11.0605 12.2707 11.1494 12.5607 11.4394C12.8507 11.7294 12.9396 12.0711 12.9728 12.3182C13.0003 12.5228 13.0001 12.7608 13 12.9606V13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H11.0394C11.2393 10.9999 11.4772 10.9997 11.6819 11.0273ZM11.9954 7C11.4456 7 10.9999 7.44772 10.9999 8C10.9999 8.55228 11.4456 9 11.9954 9H12.0044C12.5542 9 12.9999 8.55228 12.9999 8C12.9999 7.44772 12.5542 7 12.0044 7H11.9954Z" fill="black" />
                      </svg>
                    </span>
                  </OverlayTrigger>
                </h4>
              </Col>

              {Array.isArray(enquiriesList?.data) &&
                enquiriesList?.data.length > 0 ? (
                enquiriesList?.data.slice(0, 3).map((ele, index) => (
                  <Col
                    lg={4}
                    key={index}
                    className="display-table  mb-3"
                  >
                    <div className="leads-pending-card table-cell">
                      <div className="leads-pending-pro">
                        <div className="pending-pro-view cursor-pointer"
                          onClick={() => Navigate(`/enquiry-detail/${ele?._id}`)}
                        >
                          <div>
                            <h3>{ele?.service?.serviceName}</h3>
                            <p>{ele?.category?.categoryName}</p>
                            {ele?.city ? (
                              <p>{truncateText(ele?.city, 6)}</p>
                            ) : (
                              <p>{formatAndTruncateText(ele?.address, 6)}</p>
                            )}
                          </div>
                        </div>
                        <span className="update-enquiry" >
                          <reactform.Select value={ele?.status} aria-label="Default select example" className="update-enquiry-status-dashboard"
                            onChange={(e) => handleUpdateStatus(ele?._id, e.target.value, ele?._id)}
                            disabled={ele?.status === "Work Complete"}
                          >
                            <option value="Enquired">Enquired</option>
                            <option value="Work Complete">Work Complete</option>
                            <option value="Didn’t hire anyone">Didn’t hire anyone</option>
                          </reactform.Select>
                        </span>
                      </div>

                      <div className="pending-pro-quote mt-4"
                      >
                        <p>You have {ele?.response} responses from our members</p>
                      </div>
                      {/* <span className="active-shape">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="45"
                          height="45"
                          viewBox="0 0 45 45"
                          fill="none"
                        >
                          <path
                            d="M0 15C0 6.71573 6.71573 0 15 0H45L22.5 22.5L0 45V15Z"
                            fill="#337FE0"
                          />
                        </svg>
                      </span> */}
                    </div>
                  </Col>
                ))
              ) : (
                <div>No Data Found</div>
              )}

              <Col lg={12}>
                <div className="view-all-enquiries">
                  <Link to="/your-enquiries">View All Enquiries</Link>
                </div>
              </Col>
              <Col lg={12}>
                <h4>Your Account</h4>
              </Col>
              <Row>
                <Col lg={6}>
                  <div className="contact-us-box">
                    <div>
                      <h3 className="mb-0">
                        Phone No. Verification{" "}
                        <span>
                          {userDetail?.isPhoneNoVerified && <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                          >
                            <rect
                              width="30"
                              height="30"
                              rx="15"
                              transform="matrix(-1 0 0 1 31 1)"
                              fill="white"
                              stroke="#1994EC"
                              stroke-width="2"
                            />
                            <path
                              d="M22.5625 12.516L13.4916 20.2188L9.4375 16.1647"
                              stroke="#1994EC"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>}
                        </span>
                      </h3>

                      {userDetail?.isPhoneNoVerified ?
                        <h6 className="mb-3">Your phone number is verified</h6> :
                        <h6 className="mb-3">Your phone number is not verified</h6>
                      }

                      {userDetail?.isPhoneNoVerified ?

                        null :
                        <button class="theme-comm-btn" onClick={handlePhoneVerify}>
                          Verify Now
                        </button>


                      }

                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                      >
                        <rect
                          x="16"
                          y="6"
                          width="28"
                          height="48"
                          rx="6"
                          fill="#D9D9D9"
                          fill-opacity="0.4"
                          stroke="black"
                          stroke-width="2"
                        />
                        <circle cx="30" cy="46" r="3" fill="black" />
                        <path
                          d="M36 7.5V6.5H35H25H24V7.5V9C24 9.01294 24 9.02608 24 9.03938C23.9999 9.23926 23.9997 9.47723 24.0272 9.68188C24.0604 9.92893 24.1493 10.2707 24.4393 10.5607C24.7293 10.8507 25.0711 10.9396 25.3181 10.9728C25.5228 11.0003 25.7607 11.0001 25.9606 11C25.9739 11 25.9871 11 26 11H34C34.0129 11 34.0261 11 34.0394 11C34.2393 11.0001 34.4772 11.0003 34.6819 10.9728C34.9289 10.9396 35.2707 10.8507 35.5607 10.5607L34.8536 9.85355L35.5607 10.5607C35.8507 10.2707 35.9396 9.92893 35.9728 9.68188C36.0003 9.47723 36.0001 9.23926 36 9.03938C36 9.02608 36 9.01295 36 9V7.5Z"
                          stroke="black"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </Col>
                <Col lg={6} className="mt-3 mt-lg-0">
                  <div className="contact-us-box">
                    <div>
                      <h3 className="mb-0">Email Verification
                        {userDetail?.isPasswordSet &&
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                            >
                              <rect
                                width="30"
                                height="30"
                                rx="15"
                                transform="matrix(-1 0 0 1 31 1)"
                                fill="white"
                                stroke="#1994EC"
                                stroke-width="2"
                              />
                              <path
                                d="M22.5625 12.516L13.4916 20.2188L9.4375 16.1647"
                                stroke="#1994EC"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>}
                      </h3>
                      {userDetail?.isPasswordSet ? <h6 className="mb-3">Your Email is verified</h6> : <h6 className="mb-3">Your Email is not verified</h6>}
                      {/* <button class="theme-comm-btn">
                        {" "}
                        {userDetail?.isPasswordSet ? "Verified" : "Verify Now"}
                      </button> */}
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                      >
                        <path
                          d="M8.5 20C8.5 17.6147 8.50212 15.9263 8.67414 14.6469C8.84229 13.3962 9.15611 12.687 9.67157 12.1716C10.187 11.6561 10.8962 11.3423 12.1469 11.1741C13.4263 11.0021 15.1147 11 17.5 11H42.5C44.8853 11 46.5737 11.0021 47.8531 11.1741C49.1038 11.3423 49.813 11.6561 50.3284 12.1716C50.8439 12.687 51.1577 13.3962 51.3259 14.6469C51.4979 15.9263 51.5 17.6147 51.5 20V41.5H8.5V20Z"
                          fill="#D9D9D9"
                          fill-opacity="0.5"
                          stroke="black"
                          stroke-width="2"
                        />
                        <path
                          d="M9.16667 41.5C7.69391 41.5 6.5 42.6939 6.5 44.1667C6.5 46.5599 8.4401 48.5 10.8333 48.5H49.1667C51.5599 48.5 53.5 46.5599 53.5 44.1667C53.5 42.6939 52.3061 41.5 50.8333 41.5H9.16667Z"
                          stroke="black"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </Col>
              </Row>
            </Row>
          </div>
        </Container>
        <div className="another-search-sec">
          <h3>Want to make another search?</h3>
          <p>
            Search the type of service you require and we’ll help to connect you
            with someone new.
          </p>
          {/* <Form className="cmn-form-set">
            <Form.Group className="mb-3" controlId="formBasicEmail" onClick={handleChange}>
              <Form.Control type="email" placeholder="Search here" />
            </Form.Group>
          </Form> */}

          <Formik
            initialValues={{ services: "", vendorServices: [] }}
            validationSchema={validationSchema} // Ensure vendorServices field is initialized
            onSubmit={(values) => {
              console.log("Form Submitted", values);
              if (values.services && values.services.length > 0) {
                const [firstService] = values.services; // Destructure the first service
                setShow(true);
                setSelectedData({
                  service: firstService.value,
                  category: firstService.category,
                });
              }
            }}
          >
            {({ setFieldValue, errors, touched, values }) => (
              <Form>
                <div className="w-100">
                  <div>
                    <Field name="services">
                      {({ field, form }) => (
                        <Select
                          menuPlacement="top"
                          options={options}
                          styles={customStyles}
                          className="w-100"
                          value={form.values.services} // Prefill works here
                          onChange={(selectedOptions) => {
                            const optionsArray = Array.isArray(selectedOptions)
                              ? selectedOptions
                              : [selectedOptions];

                            form.setFieldValue("services", optionsArray);

                            // Group services by category
                            const groupedServices = optionsArray.reduce(
                              (acc, option) => {
                                const { category, value } = option;
                                if (!acc[category]) {
                                  acc[category] = { category, services: [] };
                                }
                                acc[category].services.push(value);
                                return acc;
                              },
                              {}
                            );

                            const vendorServices = Object.values(
                              groupedServices
                            ).map((group) => ({
                              category: group.category,
                              services: group.services,
                            }));

                            // Set grouped services to Formik's field value
                            form.setFieldValue(
                              "vendorServices",
                              vendorServices
                            );

                            // Open the modal if services have a value
                            if (optionsArray.length > 0) {
                              const [firstService] = optionsArray; // Extract the first service
                              setShow(true);
                              setSelectedData({
                                service: firstService.value,
                                category: firstService.category,
                              });
                            }
                          }}
                          placeholder="Search here"
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Layout>
      <TellUsMoreModal
        show={show}
        handleClose={handleClose}
        selectedData={selectedData}
        userDetail={userDetail}
      />
      <PhoneVerifyModal
        phoneVerifyModal={phoneVerifyModal}
        handlephoneVerifyModalClose={handlephoneVerifyModalClose}
        refetch={refetch}
      />


      <GiveReviewModal
        review={review}
        handleReviewClose={handleReviewClose}
        leadID={leadID}
      />
    </>
  );
}
